module.exports = __webpack_public_path__ + "media/assets/ruby_red-4dfd3218d38cee3ed77d765fb85e2ed8.svg";